import * as React from "react";

function BullseyePointerIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M256 464c114.9 0 208-93.1 208-208S370.9 48 256 48 48 141.1 48 256c0 5.5.21 10.9.63 16.3L1.754 286.1C.596 276.2 0 266.2 0 256 0 114.6 114.6 0 256 0s256 114.6 256 256-114.6 256-256 256c-10.2 0-20.2-.6-30.1-1.8l13.8-46.8c5.4.4 10.8.6 16.3.6zm11.9-96.6c56.3-6 100.1-53.6 100.1-111.4 0-61.9-50.1-112-112-112-57.8 0-105.4 43.8-111.4 100.1l-48.58 14.3c-.01-.8-.02-1.6-.02-2.4 0-88.4 71.6-160 160-160s160 71.6 160 160-71.6 160-160 160c-.8 0-1.6-.9-2.4-.9l14.3-47.7zM39.01 308.5l204.89-60.2c12.1-3.6 23.4 6.8 19.8 19.8l-60.2 204c-4.1 14.8-23.2 16.5-29.7 3.5l-28.6-57.3c-.7-2.2-1.6-2.6-2.6-3.7l-87.97 88c-12.5 12.5-32.76 12.5-45.257 0s-12.497-32.7 0-45.2l87.987-88c-1.1-1-2.34-1.9-3.68-2.6l-57.31-28.6c-12.99-6.5-11.3-25.6 2.64-29.7z"
  }));
}

const ForwardRef = React.forwardRef(BullseyePointerIcon);
export default ForwardRef;